import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { downloadApk } from 'api/auth.api';
import downloadFile from 'constants/helper/downloadFile';

export const useDownloadApp = () => {
  const [progress, setProgress] = useState(0);

  const mutation = useMutation({
    mutationFn: () => downloadApk(setProgress),

    onSuccess: (response) => {
      downloadFile(response.data, 'App-release.apk');
      setProgress(0);
    },

    onError: (error) => {
      console.error('APK download failed', error);
      setProgress(0);
    },
  });

  return {
    ...mutation,
    progress,
  };
};
